import { AdminCheckOperationReportComponent } from "../../../components/SupportSystem/OperationReportForm/AdminCheckOperationReportComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
export function AdminCheckOperationReportsContainer () {
    const titleName = "แบบรายงานการดำเนินการพัฒนาฝีมือแรงงานของผู้ได้รับเงินช่วยเหลือหรืออุดหนุน";
    return(
        <div className="page-container bg-landing">
            {/* <NavbarSupportSystem /> */}
            <NavbarSupportSystem/>
            <HeadTitle title={titleName} />
            <AdminCheckOperationReportComponent/>
            <Footer />
        </div>   
    )
}